import React, { FC } from "react";
import { IIconProps } from "./types";
import { Icon } from "./Icon";

export const ErrorIcon: FC<IIconProps> = (props) => (
  <Icon baseWidth={24} baseHeight={24} {...props}>
    {(width, height, color) => (
      <svg width={width} height={height} viewBox="0 0 17.554 15.16">
        <path
          id="Icon_material-report-problem"
          data-name="Icon material-report-problem"
          d="M1.5,18.16H19.054L10.277,3Zm9.575-2.394h-1.6v-1.6h1.6Zm0-3.192h-1.6V9.383h1.6Z"
          transform="translate(-1.5 -3)"
          fill={color}
        />
      </svg>
    )}
  </Icon>
);
